/* DeleteButton.tsx generated by @compiled/babel-plugin v0.40.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3um015vq%7Bvisibility%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._154ix0bf%7Btop%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xi2x0bf%7Bright%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbykb7n%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._13t3idpf%20span%7Bline-height%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._154ir5cr%7Btop%3Avar(--ds-space-negative-050%2C-4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xi2r5cr%7Bright%3Avar(--ds-space-negative-050%2C-4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbf6fq%7Bwidth%3A18px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3if6fq%7Bheight%3A18px%7D");
import Button, { type ButtonProps } from '@atlaskit/button/standard-button';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { deleteEmojiLabel } from '../../util/constants';
import { emojiDeleteButton } from './styles';
import { Box } from '@atlaskit/primitives/compiled';
import FeatureGates from '@atlaskit/feature-gate-js-client';
const isRefreshEmojiPickerEnabled = (): boolean => {
  if (!FeatureGates.initializeCompleted()) {
    return false;
  }

  // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
  const isEnabled = FeatureGates.getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false);
  return isEnabled;
};
const styles = {
  boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const deleteButton = null;
const refreshedDeleteButton = null;

/**
 * Test id for wrapper Emoji delete button
 */
export const RENDER_EMOJI_DELETE_BUTTON_TESTID = 'render-emoji-delete-button';
const DeleteButton = (props: ButtonProps): JSX.Element => {
  const isRefreshEnabled = isRefreshEmojiPickerEnabled();
  return <span
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax(["_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf", isRefreshEnabled && "_154ir5cr _1xi2r5cr", emojiDeleteButton])} data-testid={RENDER_EMOJI_DELETE_BUTTON_TESTID}>
			<Button iconBefore={<Box xcss={styles.boxWrapperStyle}>
						{isRefreshEnabled ? <CrossCircleIcon label={deleteEmojiLabel} color={"var(--ds-icon, #292A2E)"} size="medium" /> : <CrossCircleIcon label={deleteEmojiLabel} color={"var(--ds-text-subtle, #505258)"} size="small" />}
					</Box>} onClick={props.onClick}
    // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
    appearance="subtle-link" spacing="none" testId="emoji-delete-button" tabIndex={-1} />
		</span>;
};
export default DeleteButton;